import { useEnvStore } from "@/os/env/useEnvStore";
import { cloudApi } from "./cloud";
import { mockApi } from "./mock/api";
import type { DataAPI } from "./types";

/**
 * Single entry point for all OS data access.
 * Branches between Lovable Cloud (production) and the in-memory mock (sandbox)
 * based on the active env in `useEnvStore`.
 */
export const db = (): DataAPI =>
  useEnvStore.getState().env === "sandbox" ? mockApi : cloudApi;

export type { DataAPI } from "./types";